var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.75H8.5C8.09 20.75 7.75 20.41 7.75 20C7.75 19.59 8.09 19.25 8.5 19.25H17C19.86 19.25 21.25 17.86 21.25 15V9C21.25 6.14 19.86 4.75 17 4.75H7C4.14 4.75 2.75 6.14 2.75 9V15.3C2.75 15.71 2.41 16.05 2 16.05C1.59 16.05 1.25 15.71 1.25 15.3V9C1.25 5.35 3.35 3.25 7 3.25H17C20.65 3.25 22.75 5.35 22.75 9V15C22.75 18.65 20.65 20.75 17 20.75Z",
    fill: "#5E1899"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.25C10.21 15.25 8.75 13.79 8.75 12C8.75 10.21 10.21 8.75 12 8.75C13.79 8.75 15.25 10.21 15.25 12C15.25 13.79 13.79 15.25 12 15.25ZM12 10.25C11.04 10.25 10.25 11.04 10.25 12C10.25 12.96 11.04 13.75 12 13.75C12.96 13.75 13.75 12.96 13.75 12C13.75 11.04 12.96 10.25 12 10.25Z",
    fill: "#5E1899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15.25C18.09 15.25 17.75 14.91 17.75 14.5V9.5C17.75 9.09 18.09 8.75 18.5 8.75C18.91 8.75 19.25 9.09 19.25 9.5V14.5C19.25 14.91 18.91 15.25 18.5 15.25Z",
    fill: "#5E1899"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 22.75C3.34 22.75 1.78 21.87 0.940002 20.44C0.490002 19.72 0.25 18.87 0.25 18C0.25 15.38 2.38 13.25 5 13.25C7.62 13.25 9.75 15.38 9.75 18C9.75 18.87 9.51 19.72 9.06 20.45C8.22 21.87 6.66 22.75 5 22.75ZM5 14.75C3.21 14.75 1.75 16.21 1.75 18C1.75 18.59 1.90997 19.17 2.21997 19.67C2.79997 20.65 3.87 21.25 5 21.25C6.13 21.25 7.20003 20.65 7.78003 19.68C8.09003 19.17 8.25 18.6 8.25 18C8.25 16.21 6.79 14.75 5 14.75Z",
    fill: "#5E1899"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06992 19.7901C5.87992 19.7901 5.68989 19.7201 5.53989 19.5701L3.4299 17.4601C3.1399 17.1701 3.1399 16.6901 3.4299 16.4001C3.7199 16.1101 4.1999 16.1101 4.4899 16.4001L6.59989 18.5101C6.88989 18.8001 6.88989 19.2801 6.59989 19.5701C6.44989 19.7201 6.25992 19.7901 6.06992 19.7901Z",
    fill: "#5E1899"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93009 19.8204C3.74009 19.8204 3.55012 19.7504 3.40012 19.6004C3.11012 19.3104 3.11012 18.8304 3.40012 18.5404L5.5101 16.4304C5.8001 16.1404 6.2801 16.1404 6.5701 16.4304C6.8601 16.7204 6.8601 17.2004 6.5701 17.4904L4.46011 19.6004C4.31011 19.7504 4.12009 19.8204 3.93009 19.8204Z",
    fill: "#5E1899"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundsActive);
export default __webpack_public_path__ + "static/media/refunds_active.45533ad5cc2dd7e04f8d0fb969e2bdd9.svg";
export { ForwardRef as ReactComponent };